import errorMessage_en from './errorMessage_en';

const locale_en = {
	Internet_banking: 'Internet Banking',
	hsbc_logo: 'HSBC Hong Kong Banking Services',
	timeout_title: 'The session is going to be expired, do you want to continue ?',
	timeout_quit: 'Quit',
	timeout_continue: 'Continue',
	homeTitle: 'Strategic Financial Planning',
	footer_copyright: "©Copyright. The Hongkong and Shanghai Banking Corporation Limited 2002-{endYear}. All rights reserved.",
	design_for_hk: "This website is designed for use in Hong Kong. ",
	cross_border: "<a href='https://www.hsbc.com.hk/digital/cross-border-banking/' target='_blank'>Cross border disclosure</a>",
	customer_landing: 'Welcome back, ',
	hello: 'Welcome back, QY!',
	superHello: 'Welcome back, { someone } !',
	Collapse_Menu: 'Collapse Menu',

	...errorMessage_en
};

export default locale_en;
